import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks";

function fetchOrderStatus(params, tabStatus) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(`/admin/product-order-histories`, baseUrl);

  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  const status = tabStatus ?? params.status;
  if (status) {
    endpointUrl.searchParams.append("status", status);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }

  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.productName) {
    endpointUrl.searchParams.append("productName", params.productName);
  }

  if (params.orderNo) {
    endpointUrl.searchParams.append("orderNo", params.orderNo);
  }

  if (params.orderer) {
    endpointUrl.searchParams.append("orderer", params.orderer);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    pageSize: 5,
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useOrderStatus(params = {}, status) {
  return usePaginationQuery(
    [
      "product-order-histories",
      params.type,
      params.status,
      params.from,
      params.to,
      params.productName,
      params.orderNo,
      params.orderer,
      status,
    ],
    (paginationState) =>
      fetchOrderStatus({ ...params, ...paginationState }, status)
  );
}

export async function fetchOrderStatusDownload() {
  const { data } = await http(`/admin/product-order-history-download`, {
    responseType: "blob",
  });

  return data;
}

export function useOrderStatusDownload() {
  const { data, ...raResult } = useQuery(
    ["product-order-history-download"],
    () => fetchOrderStatusDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

export async function fetchProductOrderStatuses() {
  const { data } = await http(`/admin/product-order-status`);

  return data;
}

export function useProductOrderStatuses() {
  const { data, ...raResult } = useQuery(["product-order-status"], () =>
    fetchProductOrderStatuses()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
